import { useSliceContext } from "@components/SliceProvider"
import { useEffect, useState } from "react"
import { Button } from "@components/ui/base/button"

export const chainData = {
  1: {
    label: "Ethereum Mainnet",
    url: "https://mainnet.slice.so"
  },
  5: {
    label: "Ethereum Goerli (testnet)",
    url: "https://testnet.slice.so"
  },
  10: {
    label: "Optimism",
    url: "https://optimistic.slice.so"
  },
  8453: {
    label: "Base Mainnet",
    url: "https://slice.so"
  },
  84531: {
    label: "Base Goerli (testnet)",
    url: "https://base-testnet.slice.so"
  }
}

export const NETWORK_VIEW = (params: any) => {
  const { appChainId } = useSliceContext()
  const { switchNetwork, isSwitchingNetwork } = useSliceContext()
  const [showHelptext, setShowHelptext] = useState(false)

  useEffect(() => {
    if (!showHelptext) {
      setTimeout(() => setShowHelptext(true), 2000)
    }
  }, [])

  return (
    <div className="sl-text-center">
      <div className="sl-pb-6">
        <h1 className="sl-fonts">
          {isSwitchingNetwork
            ? `Connecting to ${chainData[appChainId].label}`
            : "Switch network"}
        </h1>
      </div>
      {!isSwitchingNetwork && (
        <p className="sl-text-lg">
          Connect to the{" "}
          <span className="sl-font-black">{chainData[appChainId].label}</span>{" "}
          Network
        </p>
      )}
      <div className="sl-flex sl-justify-center sl-py-4">
        <Button onClick={() => switchNetwork()} loading={isSwitchingNetwork}>
          Switch network
        </Button>
      </div>

      {isSwitchingNetwork && showHelptext && (
        <p className="sl-text-muted-foreground">
          Switch network in your wallet
        </p>
      )}
    </div>
  )
}

export default NETWORK_VIEW
